// src/components/Blocks/Banner/View.jsx
import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import './styles.css';

const BannerView = (props) => {
  const { data } = props;
  const { image, titleText, text, buttonText, buttonLink, styleTextInEvidence } = data;

  // Gestione dell'immagine caricata
  const imageSrc = image?.data
    ? `data:${image['content-type']};base64,${image.data}`
    : image?.download || image;
  
  // Verifica se tutti i campi di testo sono vuoti
  const allTextFieldsEmpty = !titleText && !text && !buttonText;
  
  // Determina se visualizzare l'overlay o meno
  const showOverlay = !allTextFieldsEmpty;

  // Determina le classi CSS in base allo stile selezionato
  // Applica le classi di stile solo se c'Ã¨ almeno un campo di testo compilato
  const contentClassName = showOverlay 
    ? `banner-content ${styleTextInEvidence ? `banner-style-${styleTextInEvidence}` : ''}`
    : 'banner-content';
  const titleClassName = `banner-titletext ${showOverlay && styleTextInEvidence ? `banner-titletext-${styleTextInEvidence}` : ''}`;
  const textClassName = `banner-text ${showOverlay && styleTextInEvidence ? `banner-text-${styleTextInEvidence}` : ''}`;
  const buttonClassName = `banner-button ${showOverlay && styleTextInEvidence ? `banner-button-${styleTextInEvidence}` : ''}`;

  return (
    <div className="full-width-banner">
      {imageSrc && (
        <>
          <img src={imageSrc} alt={text || 'Banner'} className="banner-background-image" />
          
          {/* Mostra il div del contenuto solo se c'Ã¨ almeno un campo di testo compilato */}
          {showOverlay && (
            <div className={contentClassName}>
              {titleText && <h1 className={titleClassName}>{titleText}</h1>}
              {text && <p className={textClassName}>{text}</p>}
              {buttonText && buttonLink && (
                <UniversalLink href={buttonLink} className={buttonClassName}>
                  {buttonText}
                </UniversalLink>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BannerView;